<template>
  <div class="atlas-opt-in-landing">
    <AtlasOptInHero>
      <template #buttons>
        <div class="atlas-opt-in-landing__button-section">
          <SrpButton size="big" color="teal" fill="solid" :isDisabled="hasOptedIn || isProcessing" @click="trialClicked">
            {{ isProcessing ? "Signing up..." : "Sign Up for Trial" }}
          </SrpButton>
          <div v-if="hasOptedIn" class="atlas-opt-in-landing__opted-in-message">
            <strong>Signed up - We'll reach out soon!</strong>
          </div>
        </div>
        <!--<SrpButton size="big" color="gray" fill="outlined" @click="handleSeeHowItWorks">See how it works</SrpButton>-->
      </template>
    </AtlasOptInHero>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import AtlasOptInHero from "@components/AtlasOptInHero.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import FeatureFlagCache from "@logic/FeatureFlagCache";
import ContentCalendarRepo from "@repos/ContentCalendarRepo";
import { MetricSender } from "@/helpers/MetricSender";

const route = useRoute();

const hasOptedIn = ref(false);
const isProcessing = ref(false);

const customerId = ref(route.params.customerId as string);

onMounted(async () => {
  hasOptedIn.value = await FeatureFlagCache.GetFeature("atlas-opt-in");

  MetricSender.sendMetric("Cust-Calendar-Landing-PageView", { customerId: customerId.value });
});

const trialClicked = async () => {
  if (isProcessing.value || hasOptedIn.value) return;

  isProcessing.value = true;

  await ContentCalendarRepo.optInToAtlas(customerId.value);
  // Refresh the feature flag cache
  await FeatureFlagCache.Refresh(customerId.value);
  hasOptedIn.value = true;
  isProcessing.value = true;
};
</script>

<style scoped lang="scss">
.atlas-opt-in-landing {
  min-height: 100vh;
  background: white;

  &__button-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__opted-in-message {
    font-size: 16px;
    //color: #118689;

    strong {
      font-weight: 700;
    }
  }
}
</style>
